<template>
<div class="kvkk-form">
    <button type="button" @click="formKVKK=true" class="kvkk-form__trigger flex text-sm items-center cursor-pointer w-fit">
        <span class="kvkk-form__checkbox w-6 h-6 flex-none bg-white border py-0.5 px-1 flex items-center mr-1 my-1">
          <template v-if="checked">
            <font-awesome-icon :icon="'fa-solid fa-check'"></font-awesome-icon>
          </template>
        </span>  
        <span class="text-red-800 flex h-6 items-center mr-1 px-1 text-lg">*</span>
        <span class="flex text-xs flex-wrap mb-1">
            Kişisel verilerimin yapılan&nbsp; bilgilendirme doğrultusunda işlenmesine onayım vardır.
        </span>      
    </button>
    <Teleport to="body" :disabled="!formKVKK">
        <div   
        v-if="formKVKK"
        style="height: 100vh;  position: fixed; top:0;  left: 0; width: 100%;  z-index: 80; background: rgb(0 0 0 / 82%); margin: 0;"  
     >  
       <div  class="h-full mx-auto py-5 flex items-center justify-center">
         <div class=" relative max-w-xl w-full z-index-1">
         <div 
             class="absolute inset-0 bg-gradient-to-r from-teal-700 to-teal-500 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl z-index-0">
         </div>
         <div 
             class="bg-white relative p-8 rounded shadow-lg max-w-xl w-full z-index-1"    
         >
             
             <h1 class="text-lg font-semibold mb-4">{{   $t('Aydınlatma Metni') }}</h1>
          
                <p> 
                    Formda doldurmuş olduğunuz bilgilerden kişisel veri niteliğinde olan ad-soyadı, e-posta adresi ve telefon numarası bilgileri, formdaki diğer işletme bilgileri ile birlikte dijital pazarlama hizmetine ilişkin talebinizin işleme alınabilmesi, hizmetten yararlandırılabilmeniz için tarafınıza ulaşılabilmesi/bilgi verilebilmesi ve siz reddedene kadar İnanç Turizm’in ticari işletmelere yönelik avantajlı ürün, hizmet ve kampanyalarının tarafınıza reklam ve tanıtımının yapılabilmesi amacıyla işlenecek ve bu doğrultuda Dijital Pazarlama Danışmanlığı hizmetini sağlayacak ve çözüm ortaklarımıza aktarılabilecektir.
                </p>
                 
                 <div class="w-full flex justify-between space-x-2">
                     <button type="button" @click="confirmKvkk()" class="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600">
                         {{  $t('Onaylıyorum') }}
                     </button>
                     <button type="button"  @click="closeForm()" class="bg-slate-100 text-slate-600 py-2 px-4 rounded hover:bg-slate-200 border border-slate-200">
                         {{ $t('Cancel') }}
                     </button>
                 </div>
          
             </div>
         </div>
         </div>
     </div>
    </Teleport>
</div>
</template>
<script setup>
import { ref, watch } from 'vue';   


const emit = defineEmits(["confirm"]);
const formKVKK = ref(false)
const checked = ref(false)
const confirmKvkk = () =>{
    checked.value = true;
    emit("confirm",true);
    formKVKK.value = false;
}

const openForm = () =>{
    formKVKK.value = true;
}

const closeForm = () =>{
    checked.value = false;
    emit("confirm",false);
    formKVKK.value = false;
}

defineExpose({
    openForm,
    closeForm
})

</script>
